module.exports = __webpack_public_path__ + "img/hyp-r.9d924ade.jpg";